/* ============================================================
   BIBNEST — Landing-style product page interactions
   - Horizontal scrollers with prev/next arrows
   - "Read more" review expansion
   - Daily-resetting countdown timer
   - Bundle selector -> updates product quantity input
   - Sticky add-to-cart bar visibility

   Idempotent: this file may be included by several sections and
   re-run by the theme editor. Every element is guarded with a
   data-bn-bound flag so nothing binds twice.
   ============================================================ */
(function () {
  'use strict';

  function bound(el, key) {
    var attr = 'data-bn-bound' + (key ? '-' + key : '');
    if (el.hasAttribute(attr)) return true;
    el.setAttribute(attr, '');
    return false;
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers() {
    document.querySelectorAll('[data-bn-scroller]').forEach(function (scroller) {
      if (bound(scroller)) return;
      var track = scroller.querySelector('[data-bn-track]');
      var prev = scroller.querySelector('[data-bn-prev]');
      var next = scroller.querySelector('[data-bn-next]');
      if (!track) return;

      function amount() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Read more (reviews) ---------- */
  function initReadMore() {
    document.querySelectorAll('[data-bn-readmore]').forEach(function (btn) {
      if (bound(btn)) return;
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-bn-review]');
        if (!card) return;
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = btn.getAttribute(open ? 'data-less' : 'data-more') ||
          (open ? 'Read less' : 'Read More');
      });
    });
  }

  /* ---------- Countdown (resets every day at local midnight) ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-bn-countdown]').forEach(function (el) {
      if (bound(el)) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = new Date();
        var end = new Date(now);
        end.setHours(23, 59, 59, 0);
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 3.6e6);
        var m = Math.floor((diff % 3.6e6) / 6e4);
        var s = Math.floor((diff % 6e4) / 1e3);
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Bundle selector ---------- */
  function initBundles() {
    document.querySelectorAll('[data-bn-bundles]').forEach(function (group) {
      if (bound(group)) return;
      var form = group.closest('form[action*="/cart/add"]') ||
        document.querySelector('product-form form, form[action*="/cart/add"]');
      function applyQty(qty) {
        if (!form) return;
        var input = form.querySelector('input[name="quantity"]');
        if (input) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) applyQty(radio.getAttribute('data-qty') || '1');
        });
        if (radio.checked) applyQty(radio.getAttribute('data-qty') || '1');
      });
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky() {
    var sticky = document.querySelector('[data-bn-sticky]');
    if (!sticky || bound(sticky)) return;
    var anchor = document.querySelector('product-form, .product-form');
    var stickyBtn = sticky.querySelector('[data-bn-sticky-btn]');
    function isInView(node) {
      if (!node) return false;
      var r = node.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var realBtn = document.querySelector('product-form button[type="submit"], .product-form__submit');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (realBtn && isInView(anchor)) realBtn.click();
      });
    }
    function onScroll() {
      var show = anchor ? (!isInView(anchor) && window.scrollY > 600) : window.scrollY > 600;
      sticky.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- UGC videos: muted autoplay while in view (no sound) ---------- */
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initUgc() {
    document.querySelectorAll('[data-bn-ugc-item]').forEach(function (item) {
      if (bound(item)) return;
      var video = item.querySelector('video');
      if (!video) return;
      // Always silent — force muted in case markup is cached/edited.
      video.muted = true;
      video.removeAttribute('controls');

      var reduce = prefersReducedMotion();
      // `paused` tracks the user's explicit intent so the IntersectionObserver
      // never overrides a manual pause. Reduced-motion users start paused.
      var userPaused = reduce;

      function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }

      // Accessible pause/play control (WCAG 2.2.2 — Pause, Stop, Hide).
      var frame = item.querySelector('.bn-ugc__frame') || item;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bn-ugc__toggle';
      var PAUSE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
      var PLAY_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5l12 7-12 7z"/></svg>';
      function syncToggle() {
        var playing = !video.paused;
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        toggle.innerHTML = playing ? PAUSE_ICON : PLAY_ICON;
        item.classList.toggle('is-paused', !playing);
      }
      toggle.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
        syncToggle();
      });
      video.addEventListener('play', syncToggle);
      video.addEventListener('pause', syncToggle);
      frame.appendChild(toggle);
      syncToggle();

      // Autoplay (muted) only while in view to save bandwidth, and never when
      // the user prefers reduced motion or has manually paused.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !userPaused) { play(); } else { video.pause(); }
          });
        }, { threshold: 0.5 });
        io.observe(item);
      } else if (!userPaused) {
        play();
      }
    });
  }

  function initAll() {
    initScrollers();
    initReadMore();
    initCountdowns();
    initBundles();
    initSticky();
    initUgc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', initAll);
})();

/* ── Funnel pre-landers (body.template-funnel) ───────────────────────
   Only on product.funnel-* templates. Two behaviours:
   1) Relabel the buy button so it states the quantity explicitly — it must
      be obvious that one tap claims the full 2-for-1 (2 bottles).
   2) After a successful add (cart-update event), skip the cart drawer and
      send the visitor straight to checkout. */
(function () {
  if (!document.body.classList.contains('template-funnel')) return;

  var ATC_LABEL = 'Add 2 Bottles to Cart';
  function relabelBuyButton() {
    var btn = document.querySelector('product-form .product-form__submit');
    if (!btn || btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
    var span = btn.querySelector('span');
    if (span && span.textContent.trim() !== ATC_LABEL) span.textContent = ATC_LABEL;
  }
  relabelBuyButton();
  document.addEventListener('shopify:section:load', relabelBuyButton);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    var redirecting = false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (redirecting) return;
      redirecting = true;
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      window.location.href = cartUrl.replace(/cart\/?$/, 'checkout');
    });
  }
})();
